// React.
import { useMemo } from 'react';

// Types.
import { SqlStatisticsTimeslice } from '../../../types/instance/SqlStatistics';

// Components.
import EChartsWithData from '../../chart/echarts/EChartsWithData';
import { EChartPoint, EChartTimeSeries } from '../../chart/echarts/types';

// Helpers.
import { timeSeries } from '../../../helpers/utils';
import { OracleSqlHashTimeSlice } from "../../../container/statistics/types";

// Constants.
import { CHART_DATA_TYPE } from "../../Constants";

const LABELLED_AXIS = [{ labels: true }];

export default function SqlStatisticChart(props:
                                              {
                                                  error: string | null,
                                                  loading: boolean,
                                                  data: SqlStatisticsTimeslice[] | OracleSqlHashTimeSlice[],
                                                  statistic: string,
                                                  title: string
                                              }) {
    const {error, loading, data, statistic, title} = props;

    const series = useMemo<EChartTimeSeries[]>(() => [{
        name: title,
        chartType: 'bar',
        data: timeSeries(data, 'timeslice', statistic) as EChartPoint[],
    }], [data, statistic, title]);

    return (
        <div className="card collapsible">
            <div className="card-header">
                <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                {title}
                <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                   data-bs-target={"#collapse-" + statistic} aria-expanded="false"
                   aria-controls={"collapse-" + statistic}/>
            </div>
            <div id={"collapse-" + statistic} className="card-body collapse show">
                <EChartsWithData error={error} loading={loading} length={data.length}
                                 series={series} tooltipType={CHART_DATA_TYPE.GENERIC}
                                 yAxis={LABELLED_AXIS}/>
            </div>
        </div>
    )
}
